import { createRouter, createWebHashHistory } from 'vue-router'
import HomePage from '../views/HomePage.vue'
import GlobesPage from '../views/GlobesPage.vue'
import AboutPage from '../views/AboutPage.vue'
import GlobeInfo from '../views/GlobeInfo.vue'


const routes = [
  {
    path: '/',
    name: 'home',
    component: HomePage
  },
  {
    path: '/globes',
    name: 'globes',
    component: GlobesPage
  },
  {
    path: '/about',
    name: 'about',
    component: AboutPage
  },
  {
    path: '/:globe',
    name: 'globe_info',
    component: GlobeInfo
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
